import { PaginationParams } from '@/models/api'
import { defineStore } from 'pinia'
import { ElNotification } from 'element-plus'

import * as evTripsApi from '@/api/ev-trips'

import { EvTrip } from '@/models/evTrip'
import { EvTripLog } from '@/models/evTripLog'

import { parseErrors } from '@/helpers/error-parsers'
import { showToast } from '@/helpers/messages'

import { GetEvTripsParams } from './types'
import {
  getInitialEvTripsState,
  getInitialEvTripDetailsState,
  getInitialEvTripLogsModuleState,
} from './state'

export const useEvTripsStore = defineStore('ev-trips-store', {
  state: getInitialEvTripsState,
  actions: {
    async getEvTrips(params: PaginationParams & GetEvTripsParams) {
      try {
        this.$patch({ listModule: { isLoading: true, error: null } })

        const {
          data: { data: list, meta },
        } = await evTripsApi.getEvTrips(params)

        this.$patch({
          listModule: {
            list,
            meta,
            isLoading: false,
            isInitialLoadingDone: true,
          },
        })
      } catch (e) {
        this.$patch({
          listModule: {
            error: parseErrors(e).error,
            isLoading: false,
            isInitialLoadingDone: true,
          },
        })
      }
    },

    async getEvTripDetails(id: string) {
      try {
        if (!this.tripsDetails[id]) {
          this.tripsDetails[id] = getInitialEvTripDetailsState()
        }

        this.$patch({
          tripsDetails: {
            [id]: { isLoading: true, error: null },
          },
        })

        const {
          data: { data },
        } = await evTripsApi.getEvTripDetails(id)

        this.$patch({
          tripsDetails: {
            [id]: { isLoading: false, data },
          },
        })
      } catch (e) {
        const { error } = parseErrors(e)

        this.$patch({
          tripsDetails: {
            [id]: { isLoading: false, error },
          },
        })
      }
    },

    async updateEvTripData(id: string, data: Partial<EvTrip>) {
      try {
        const {
          data: { data: updatedTrip },
        } = await evTripsApi.updateEvTripData(id, data)

        this.$patch({
          tripsDetails: {
            [id]: {
              isLoading: false,
              data: {
                ...this.tripsDetails[id]?.data,
                ...updatedTrip,
              },
            },
          },
        })

        showToast({
          message: 'Trip data updated!',
          type: 'success',
        })
      } catch (e) {
        const { error } = parseErrors(e)
        showToast({
          type: 'error',
          message: error,
        })
      }
    },

    // async getEvTripLogs(tripId: string) {
    //   try {
    //     if (!this.tripsLogs[tripId]) {
    //       this.tripsLogs[tripId] = getInitialEvTripLogsModuleState()
    //     }

    //     this.$patch({
    //       tripsLogs: {
    //         [tripId]: { isLoading: true, error: null },
    //       },
    //     })

    //     const {
    //       data: { data },
    //     } = await evTripsApi.getEvTripLogs(tripId)

    //     this.$patch({
    //       tripsLogs: {
    //         [tripId]: { isLoading: false, data },
    //       },
    //     })
    //   } catch (e) {
    //     const { error } = parseErrors(e)

    //     this.$patch({
    //       tripsLogs: {
    //         [tripId]: { isLoading: false, error },
    //       },
    //     })
    //   }
    // },

    // async createEvTripLog(tripId: string, comment: string) {
    //   try {
    //     const {
    //       data: { data: log },
    //     } = await evTripsApi.createEvTripLog(tripId, comment)

    //     const logs = this.tripsLogs[tripId]?.data ?? []

    //     this.$patch({
    //       tripsLogs: {
    //         [tripId]: {
    //           data: [log, ...logs],
    //         },
    //       },
    //     })

    //     showToast({
    //       message: 'Log created!',
    //       type: 'success',
    //     })
    //   } catch (e) {
    //     const { error } = parseErrors(e)
    //     showToast({
    //       type: 'error',
    //       message: error,
    //     })
    //   }
    // },

    async resendEvTripWaybill(tripId: string) {
      try {
        await evTripsApi.resendEvTripWaybill(tripId)

        this.$patch({
          tripsDetails: {
            [tripId]: {
              data: {
                ...this.tripsDetails[tripId]?.data,
                waybill_sent: true,
              },
            },
          },
        })

        showToast({
          message: 'Waybill resent successfully!',
          type: 'success',
        })
      } catch (e) {
        const { error } = parseErrors(e)
        showToast({
          type: 'error',
          message: error,
        })
      }
    },
  },
})
